<template>
	<Col>
		<Col v-for="(item, i) in items" :key="item?.id || i">
			<slot name="list-item" v-bind:item="item" />
		</Col>
		<Col v-intersect="endIntersect">
			<AppLoader class="loader py-4" v-if="isLoading" />
		</Col>
		<slot name="no-results">
			<h3 v-if="!isLoading && items.length === 0" class="no-results reg text-align-center">{{ noResultsMessage }}</h3>
		</slot>
	</Col>
</template>
<script>
export default {
	name: 'AppPagination',
	props: {
		useItemGetter: { type: Function },
		getItemsAction: { type: Function },
		idsToHide: { type: Array, default: () => [] },
		idsToAppend: { type: Array, default: () => [] },
		idsToPrepend: { type: Array, default: () => [] },
		additionalFetchParams: { type: Object, default: () => ({}) },
		noResultsMessage: { type: String, default: 'No items found' },
	},
	computed: {
		items() {
			// make  array unique
			const mergedIdsByOrder = [...this.idsToPrepend, ...this.idsToShow, ...this.idsToAppend];
			const relevantIds = mergedIdsByOrder.filter((id) => !this.idsToHide.includes(id));
			return [...new Set(relevantIds)].map((id) => this.useItemGetter(id));
		},
	},
	methods: {
		endIntersect(entries, observer, isIntersecting) {
			if (isIntersecting) {
				this.onScrollToBottom();
			}
		},
		onScrollToBottom() {
			if (!this.isLoading) {
				this.getItems();
			}
		},
		async getItems() {
			if (this.page === 1 || this.hasNextPage) {
				this.isLoading = true;
				const res = await this.getItemsAction({ next: this.next, page: this.page, ...this.additionalFetchParams });
				const newIds = res.ids || res.results.map(({ id }) => id);
				this.hasNextPage = Boolean(res.next);
				this.next = res.next; // will be used for cursor
				this.isLoading = false;
				this.idsToShow = [...this.idsToShow, ...newIds];
				this.page++;
			}
		},
	},
	async created() {
		await this.getItems();
	},
	data() {
		return {
			page: 1,
			idsToShow: [],
			isLoading: false,
			hasNextPage: false,
			next: null,
		};
	},
	watch: {
		additionalFetchParams: {
			handler() {
				this.page = 1;
				this.idsToShow = [];
				this.getItems();
			},
			deep: true,
		},
	},
};
</script>
<style lang="scss" scoped></style>
